module.exports = __webpack_public_path__ + "static/media/dropdown_arrow.985a5a7d.svg";